/**
 * Gallery Instant Transition
 * Forces instant scroll on the product media gallery slideshow.
 * On touch devices: CSS blocks native horizontal scroll entirely,
 * our handler detects swipe and triggers instant slide change.
 * Swipe direction is inverted (feels like rotating the object).
 */
(() => {
  function setup(gallery) {
    if (gallery._instantInit) return;
    gallery._instantInit = true;

    const slideshow = gallery.querySelector('slideshow-component');
    const scroller = gallery.querySelector('slideshow-slides');
    if (!scroller || !slideshow) return;

    // CSS: block native horizontal scroll on touch
    scroller.style.touchAction = 'pan-y pinch-zoom';

    // Force instant scroll for programmatic calls (buttons, thumbnails)
    const origScrollTo = scroller.scrollTo.bind(scroller);
    const origScrollBy = scroller.scrollBy.bind(scroller);

    scroller.scrollTo = function (opts) {
      if (typeof opts === 'object') origScrollTo({ ...opts, behavior: 'instant' });
      else origScrollTo.apply(scroller, arguments);
    };
    scroller.scrollBy = function (opts) {
      if (typeof opts === 'object') origScrollBy({ ...opts, behavior: 'instant' });
      else origScrollBy.apply(scroller, arguments);
    };

    // Touch swipe: detect direction, trigger prev/next
    let startX = 0;

    scroller.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    scroller.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - startX;

      if (Math.abs(dx) > 30) {
        // Inverted: swipe left → previous (rotate object right),
        //           swipe right → next (rotate object left)
        const action = dx < 0 ? 'previous' : 'next';
        const btn = slideshow.querySelector(`[ref="${action}"]`);
        if (btn) btn.click();
      }

    }, { passive: true });

    // Block slideshow's mousedown drag handler (desktop + touch compat)
    scroller.addEventListener('mousedown', (e) => {
      e.stopPropagation();
      e.preventDefault();
    }, { capture: true });

    // Prevent drag cursor and overflow scroll
    scroller.style.overflowX = 'hidden';
  }

  function initAll() {
    document.querySelectorAll('media-gallery').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(initAll));
  } else {
    requestAnimationFrame(initAll);
  }

  // Re-init after variant change (replaceWith inserts new media-gallery)
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'MEDIA-GALLERY') {
          requestAnimationFrame(() => setup(node));
        } else if (node.querySelector) {
          const g = node.querySelector('media-gallery');
          if (g) requestAnimationFrame(() => setup(g));
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
